import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Cambiar useRouter por useNavigate y useLocation
import Navbar from '../components/layout/AppBarSidebar';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { format } from 'date-fns';
import { useAuth } from '../context/AuthContext';

const HistoryPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate(); // Usar useNavigate en lugar de useRouter
  const location = useLocation();

  // Redirigir si el usuario no está autenticado
  useEffect(() => {
    if (!user) {
      navigate('/auth/login'); // Usar navigate para redirigir
    }
  }, [user, navigate]);

  // Si no hay usuario, no renderizar nada
  if (!user) {
    return null;
  }

  // Datos simulados
  const results = [
    { id: 1, event: 'Carrera local 5k', date: new Date(), place: 1, time: '00:20:15' },
    { id: 2, event: 'Maratón de la ciudad', date: new Date(), place: 2, time: '03:15:45' },
  ];

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ p: 3, width: '100%' }}>
          <Typography variant="h4" gutterBottom>
            Historial de Competencias
          </Typography>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="historial de competencias">
              <TableHead>
                <TableRow>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Evento</TableCell>
                  <TableCell>Lugar</TableCell>
                  <TableCell>Tiempo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {results.map((row) => (
                  <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row">
                      {format(row.date, 'MMM dd, yyyy')}
                    </TableCell>
                    <TableCell>{row.event}</TableCell>
                    <TableCell>{row.place}</TableCell>
                    <TableCell>{row.time}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </>
  );
};

export default HistoryPage;